import React, { Component } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faStopwatch } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';

class EventsEntity extends Component {
    render() {
        const { entity, event } = this.props;
        if (!this.props.edit) {
            return (
                <div>
                    <h5>{this.props.entities.data[this.props.eventEntities.data[entity].entity].title}</h5>
                    <OverlayTrigger rootClose placement="bottom" overlay={
                        <Popover id={`${entity}-popover`} style={{"maxWidth":"350px"}} title={<Moment>{this.props.eventEntities.data[entity].created}</Moment>}>
                            <Moment duration={event.started}>{this.props.eventEntities.data[entity].created}</Moment> from start of event.
                        </Popover>
                    }>
                        <span style={{"cursor":"pointer"}}> <FontAwesomeIcon className="text-primary" size="sm" icon={faStopwatch} fixedWidth /> <Moment from={event.started}>{this.props.eventEntities.data[entity].created}</Moment> </span>
                    </OverlayTrigger>
                    <FontAwesomeIcon className="text-primary" size="sm" icon={faCoins} fixedWidth /> {parseInt(this.props.eventEntities.data[entity].dkp, 10)}
                </div>
            )
        } else {
            return (
                <div>
                    edit
                </div>
            )
        }
    }
}

export default EventsEntity;


// WEBPACK FOOTER //
// ./src/Officer/EventsEntity.js